import { Col, Row } from "antd";
import { generatePath, Link } from "react-router-dom";
import Ellipsis from "../../../../common/components/views/Ellipsis";
import { LinkTargetType } from "../../../../common/types";
import { cssVariables } from "../../../../common/utils/utils";
import { AGENT_ROUTE_PATHS } from "../../paths";
import { AgentBase } from "../../types";
import { formatAgentAggregatedName } from "../../utils";
import { AgentTypeTag } from "./AgentTypeTag";

interface Props<T extends AgentBase & { representatives?: AgentBase[] }> {
  agent?: T;
  hideIdNumber?: boolean;
  showRepresentatives?: boolean;
  ellipsis?: boolean;
  showLink?: boolean;
  linkTarget?: LinkTargetType;
  textStyle?: React.CSSProperties;
}

export const AgentTypeTagWithName = <T extends AgentBase & { representatives?: AgentBase[] }>({
  agent,
  hideIdNumber,
  showRepresentatives,
  ellipsis,
  showLink,
  linkTarget,
  textStyle
}: Props<T>) => {
  const representatives =
    agent?.representatives?.length && showRepresentatives
      ? `| ${agent.representatives?.map(representative => representative.displayName).join(", ")}`
      : "";

  return agent ? (
    <Row gutter={0}>
      <Col>
        <AgentTypeTag type={agent.type} />
      </Col>
      {showLink ? (
        <Col flex="1 1 0" style={{ minWidth: 0 }}>
          <Ellipsis
            tooltip={
              hideIdNumber
                ? `${agent.aggregatedName} ${representatives}`
                : `${formatAgentAggregatedName(agent)} ${representatives}`
            }
            shouldRender={!!ellipsis}
          >
            <Link
              className="no-link-color"
              style={textStyle}
              to={generatePath(AGENT_ROUTE_PATHS.detail.to, { id: agent.id })}
              target={linkTarget}
            >
              {hideIdNumber ? agent.aggregatedName : formatAgentAggregatedName(agent)}
            </Link>

            <i className="margin-left-tiny" style={{ color: cssVariables.colorGrey }}>
              {representatives}
            </i>
          </Ellipsis>
        </Col>
      ) : (
        <Col flex="1 1 0" style={{ minWidth: 0 }}>
          <Ellipsis shouldRender={!!ellipsis} style={textStyle}>
            {hideIdNumber ? agent.aggregatedName : formatAgentAggregatedName(agent)}
          </Ellipsis>
        </Col>
      )}
    </Row>
  ) : null;
};
